import {CatalogRouteMetaDataModel} from "./catalog-route.meta-data.model";
import {BaseRouteConfig} from "../../../core/components/router/models/base-route-config";
import {ROUTE_NAMES} from "../../../core/consts";
import {ReactLazyPreload} from "../../../core/components/router/react-lazy-preload";

export class CatalogRouteConfig extends BaseRouteConfig {
  static injectables = [];

  constructor(props) {
    super(props);

    this.name = ROUTE_NAMES.catalog;
    this.path = `/catalog`;
    this.component = ReactLazyPreload(() => import("../components/catalog-container" /* webpackChunkName: "catalog-container" */ ));
    this.metadataType = CatalogRouteMetaDataModel;
  }
}
